
import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import EntityDetailLayout from '../../EntityDetailLayout';

interface TransactionLoadingProps {
  onClose: () => void;
}

const TransactionLoading: React.FC<TransactionLoadingProps> = ({ onClose }) => {
  return (
    <EntityDetailLayout title="Transaction Details" onClose={onClose}>
      <div className="space-y-6 p-2">
        {/* Amount and status skeleton */}
        <div className="flex flex-col items-center justify-center py-6">
          <Skeleton className="h-10 w-32 mb-2" />
          <Skeleton className="h-6 w-20" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Customer info skeleton */}
          <Skeleton className="h-24 w-full rounded-md" />
          
          {/* Payment method skeleton */}
          <Skeleton className="h-24 w-full rounded-md" />
        </div>
        
        {/* Details section skeleton */}
        <Skeleton className="h-40 w-full rounded-md" />
      </div>
    </EntityDetailLayout>
  );
};

export default TransactionLoading;
